






import Vue from 'vue'
import Component from 'vue-class-component'
import Status from './Status.vue'
import { ELetterStatus } from '@zunta/configurations'
import { EStatusType } from '@/components/statuses/EStatusType'
import { LETTERS_STATUSES_LABEL_MAP } from '@/constants'

@Component({
  components: { Status },
  props: {
    status: {
      status: String,
      required: true
    }
  }
})
export default class StatusLetter extends Vue {
  get type (): EStatusType {
    if (!this.$props.status) {
      return EStatusType.default
    }

    const success: any[] = [ELetterStatus.READY_TO_MAIL, ELetterStatus.EMAILED, ELetterStatus.DELIVERED]
    const process: any[] = [ELetterStatus.IN_TRANSIT, ELetterStatus.IN_LOCALAREA, ELetterStatus.PRINTED_LOCALLY, ELetterStatus.PENDING, ELetterStatus.PROCESSED_FOR_DELIVERY]
    const pending: any[] = [ELetterStatus.IN_PROCESS, ELetterStatus.SKIP, ELetterStatus.DO_NOT_BILL_RETURNED, ELetterStatus.DO_NOT_BILL_EMAIL_RETURNED]
    const attention: any[] = [ELetterStatus.NEEDS_FIX, ELetterStatus.REROUTED]
    const error: any[] = [ELetterStatus.NEEDS_REVIEW, ELetterStatus.RETURNED, ELetterStatus.EMAIL_RETURNED]

    if (success.includes(this.$props.status)) {
      return EStatusType.success
    } else if (process.includes(this.$props.status)) {
      return EStatusType.process
    } else if (pending.includes(this.$props.status)) {
      return EStatusType.pending
    } else if (attention.includes(this.$props.status)) {
      return EStatusType.attention
    } else if (error.includes(this.$props.status)) {
      return EStatusType.error
    }

    return EStatusType.default
  }

  get text (): string {
    if (!this.$props.status) {
      return ''
    }
    return LETTERS_STATUSES_LABEL_MAP[this.$props.status]
  }
}
